module.exports = __webpack_public_path__ + "src/assets/img/dilo_logo_70.b7b689c1.svg";